import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { PaginatedResults } from "@sdk/utils/paginated-results";
import type { iBookingTransaction } from "./booking-transaction-model";

export class BookingTransactionsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.bookingTransactions.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.bookingTransactions.configure(config);
  }

  bookingTransactions = Object.assign(
    new EntityServices<iBookingTransaction>(
      SDKConfig,
      "booking-transactions",
      {}
    ),
    {
      queryByBooking: async (
        bookingId: string,
        limit = 50
      ): Promise<PaginatedResults<iBookingTransaction>> => {
        const results: AxiosResponse<PaginatedResults<iBookingTransaction>> =
          await axios.post(
            SDKConfig.basePath +
              `/booking-transactions/query-by-booking/${bookingId}`,
            { limit },
            {
              headers: { Authorization: SDKConfig.token },
            }
          );
        return results.data;
      },
      queryByInvoice: async (
        customerInvoiceId: string,
        limit = 50
      ): Promise<PaginatedResults<iBookingTransaction>> => {
        const results: AxiosResponse<PaginatedResults<iBookingTransaction>> =
          await axios.post(
            SDKConfig.basePath +
              `/booking-transactions/query-by-invoice/${customerInvoiceId}`,
            { limit },
            {
              headers: { Authorization: SDKConfig.token },
            }
          );
        return results.data;
      },
      queryByBill: async (
        supplierBillId: string,
        limit = 50
      ): Promise<PaginatedResults<iBookingTransaction>> => {
        const results: AxiosResponse<PaginatedResults<iBookingTransaction>> =
          await axios.post(
            SDKConfig.basePath +
              `/booking-transactions/query-by-bill/${supplierBillId}`,
            { limit },
            {
              headers: { Authorization: SDKConfig.token },
            }
          );
        return results.data;
      },
    }
  );
}
